import { LocationFullType } from '../../components/Location/config';

export const isSubarray = (parentArray: string[], childArray: string[]) =>
  childArray.every(val => parentArray.includes(val));

export const convertLocationToBackendData = (location: LocationFullType) => {
  return {
    location_place_id: location.place_id,
    location_point: {
      type: 'Point',
      coordinates: [location.coordinates.lng, location.coordinates.lat], // PostGIS: ST_POINT(longitude, latitude)
    },
    location_country: location.country,
    location_state: location.state,
    location_city: location.city,
    location_input_main: location.inputMain,
    location_input_secondary: location.inputSecondary,
  };
};
